import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { NavLink } from 'react-router-dom';
import navIcon from 'Images/open.svg';
import iconCredential from 'Assets/Images/ic-credential.svg';
import iconBlock from 'Assets/Images/ic-block.svg';
import opacity from '../../Utils/opacity';
import { colors } from '../../Theme/constants';
import { withRouter } from 'react-router';

const SidebarStyled = styled.div`
  height: 100%;
  width: 100%;
  overflow: auto;
  background-color: #fafafa;
`;

const Head = styled.div`
  padding: 1.5rem;
  display: flex;
  align-items: center;
`;

const MenuStyled = styled.ul`
  li {
    a {
      color: ${opacity(colors.black, 95)};
      display: flex;
      align-items: center;
      height: 4rem;
      width: 98%;
      padding: 1.2rem 1.5rem;
      img {
        object-fit: contain;
        width: 1.6rem;
        margin-right: 0.8rem;
      }
      &.active {
        background-color: #e8f0fe;
        color: ${colors.blue};
        font-weight: 600;
        border-radius: 0 50px 50px 0;
      }
      &:hover {
        background-color: ${opacity(colors.black, 5)};
      }
    }
  }
`;

const menuItemMap = [
  {
    link: '/oauth2/clients',
    icon: iconCredential,
    name: 'Credentials',
  },
  {
    link: '/oauth2/app',
    icon: navIcon,
    name: 'OAuth consent screen',
  },
  {
    link: '/oauth2/can_account',
    icon: iconBlock,
    name: 'CAN Blockchain Account',
  },
];

const Sidebar = props => {
  const { className, location } = props;
  return (
    <React.Fragment>
      <SidebarStyled className={className}>
        <Head className="cp-head">
          <h5>Apis and Services</h5>
        </Head>
        <MenuStyled>
          {menuItemMap.map(item => {
            return (
              <li key={item.link}>
                <NavLink to={item.link + location.search} title={item.name}>
                  <img src={item.icon} alt={item.name} />
                  <span>{item.name}</span>
                </NavLink>
              </li>
            );
          })}
        </MenuStyled>
      </SidebarStyled>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
};

export default withRouter(Sidebar);
